// extracted by mini-css-extract-plugin
module.exports = {"container":"IssueList_container__1DP1m","issuesContainer":"IssueList_issuesContainer__NgZlK","bulkUpdate":"IssueList_bulkUpdate__er2lv"};